import {
  SuggestedGuideAvatar,
  SuggestedGuideInfoWrapper,
  SuggestedGuideName,
  SuggestedGuidePosition,
  SuggestedGuideWrapper,
} from './SuggestedGuide.style';

interface SuggestedGuideProps {
  image: string;
  name: string;
}

export const SuggestedGuide: React.FC<SuggestedGuideProps> = (props) => {
  return (
    <SuggestedGuideWrapper>
      <SuggestedGuideAvatar src={props.image} alt="" />
      <SuggestedGuideInfoWrapper>
        <SuggestedGuideName>{props.name}</SuggestedGuideName>
        <SuggestedGuidePosition>Professional guide</SuggestedGuidePosition>
      </SuggestedGuideInfoWrapper>
    </SuggestedGuideWrapper>
  );
};
